import React, { useCallback, useState } from 'react'
import { Group } from '@/model/types/goods'
import DropContent from './drop-content'

import './goods-group.scss'
import { getBEMCls } from '@/utils/classname'
import { useRequest } from 'ahooks'
import { $post } from '@/api'
import { Spin } from 'antd'
import { GoodsLibraryStore, goodsLibraryStore } from '../../store/goods-library'
import { observer } from 'mobx-react'
import GroupItem from './group-item'
import { Expaned, Column, Row } from '@/components/layout/layout'
import Iconfont from '@/components/iconfont/iconfont'
import { showLayer } from '@/utils/layer'
import RecycleBin from '../../widget/recycle-bin'
import { goodsModel } from '../edit-goods/modules/model'
import { TYPE } from '../../goods-library'
import $msg from '@/utils/message'

interface GoodsGroupProps {
    goodsLibraryStore: GoodsLibraryStore
}

const GoodsGroup: React.FC<GoodsGroupProps> = observer(props => {
    const getCls = (e?: string, m?: string) => getBEMCls('goods-group', e, m)
    const [groupArr, setGroupArr] = useState<Group[]>([])
    const [secondGroupId] = useState<number>(0)

    const { loading, run } = useRequest(
        () =>
            $post({
                url: '/goods/getgoodsgroup',
            }),
        {
            onSuccess: async (e: Group[]) => {
                if (typeof goodsLibraryStore.groupId === 'undefined') {
                    goodsLibraryStore.setActiveGroupId(0)
                }
                goodsModel.setGoodsGroup(e)
                const { number } = await $post({
                    url: '/goods/getgoodsnumber',
                })
                const addOpenStatus = e.map((item, index) => ({
                    ...item,
                    open: groupArr.length ? groupArr[index].open : false, // 缓存分组展开状态
                }))
                // 增加全部商品分组
                addOpenStatus.unshift({
                    id: 0,
                    is_default: false,
                    name: '全部商品',
                    open: true,
                    create_time: '',
                    priority: 0,
                    secondary_group: [
                        {
                            id: 0,
                            goods_num: 0,
                            name: '',
                        },
                    ],
                    goods_num: number,
                    intro: '',
                })
                // 首次加载
                if (!groupArr.length) {
                    if (e.length && addOpenStatus[0].open) {
                        props.goodsLibraryStore.setActiveGroupId(0)
                        if (e[0].secondary_group.length) {
                            props.goodsLibraryStore.setActiveSecondGroupId(0)
                        }
                    }
                }
                setGroupArr(addOpenStatus)
            },
            refreshDeps: [goodsLibraryStore.updateGroup],
        },
    )

    const handleDrop = useCallback(
        (goods_ids: number[], group_id: number | undefined, secondary_group_id?: number) => {
            $post({
                url: '/goods/changegoodsgroup',
                params: {
                    goods_ids: goods_ids,
                    group_id,
                    secondary_group_id: secondary_group_id ? secondary_group_id : undefined,
                },
            }).then(() => {
                props.goodsLibraryStore.setActiveGroupId(0)
                props.goodsLibraryStore.setActiveSecondGroupId(secondGroupId ? secondGroupId : undefined)
                props.goodsLibraryStore.setUpdateGroupStatus(!props.goodsLibraryStore.updateGroupStatus)
                props.goodsLibraryStore.setClearSelectKey(true)
                $msg('success', '更换分组成功')
                run()
            })
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [secondGroupId],
    )

    return (
        <Column className={getCls()}>
            <Spin spinning={loading} className={loading ? getCls('spin') : ''} />
            <Expaned className={getCls('content')}>
                {!!groupArr.length &&
                    groupArr.map((group, index) =>
                        group.secondary_group.length ? (
                            <div key={group.id}>
                                <GroupItem
                                    group={group}
                                    groupArr={groupArr}
                                    groupIndex={index}
                                    handleDrop={handleDrop}
                                    onClick={(val, index) => {
                                        setGroupArr(group => {
                                            const tmp = [...group]
                                            tmp[index].open = !tmp[index].open

                                            return tmp
                                        })
                                    }}
                                    secondGroupId={secondGroupId}
                                    {...props}
                                />
                            </div>
                        ) : (
                            <DropContent
                                key={group.id}
                                type={TYPE}
                                onDrop={item => {
                                    handleDrop(item.goods_ids, group.id)
                                }}
                            >
                                <GroupItem
                                    group={group}
                                    groupArr={groupArr}
                                    groupIndex={index}
                                    handleDrop={handleDrop}
                                    secondGroupId={secondGroupId}
                                    {...props}
                                />
                            </DropContent>
                        ),
                    )}
            </Expaned>
            <Row className={getCls('recycle')} onClick={() => showLayer(<RecycleBin />)}>
                <Iconfont name="icon6lajixiang-20" size={16}></Iconfont>
                <span data-margin-left-5 data-font-size-12 data-color-999>
                    回收站
                </span>
            </Row>
        </Column>
    )
})

export default GoodsGroup
